import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchLogos } from "../../../services/AuthService";
import { useNavigate } from "react-router-dom";
import ToggleSwitch from "../bootstrap/Toggle";
import { FaEye, FaPencilAlt, FaImage } from "react-icons/fa";
import { FaAngleLeft, FaAngleRight, FaRegTrashCan } from "react-icons/fa6";
import { IoSearch } from "react-icons/io5";
import { MdOutlineWifiTetheringErrorRounded } from "react-icons/md";
import Search from "../Jobick/Jobs/ui/search";
import { toast } from "react-toastify";
import { getItemsPerPage } from "../../utils/CommonFunctions";
import { colors } from "../../config/colors";
import axiosInstance from "../../../services/AxiosInstance";
import {
  HiOutlineEye,
  HiOutlinePencilAlt,
  HiOutlinePhotograph,
} from "react-icons/hi";

const ListOrganisation = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState(""); // for status filter
  const [pageVal, setPageVal] = useState(1); // for value of pagination
  const [totalOrganizations, setTotalOrganizations] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(1);
  const [organisationList, setOrganisationList] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const organisationPerPage = getItemsPerPage();
  const [loadingMockAdmin, setLoadingMockAdmin] = useState(null);
  const [showTooltip, setShowTooltip] = useState({});
  const [statusLoading, setStatusLoading] = useState(null);
  const [pageLoading, setPageLoading] = useState(false);

  const handlePreviousPageClick = () => {
    if (pageVal === 1) {
      return;
    }
    setPageLoading(true);
    setPageVal(pageVal - 1);
  };

  const handleNextPageClick = () => {
    if (pageVal >= totalPages) {
      return;
    }
    setPageLoading(true);
    setPageVal(pageVal + 1);
  };

  const handlePageChange = (page) => {
    setPageLoading(true);
    setPageVal(page);
  };

  const fetchOrganisationList = async () => {
    setLoading(1);
    try {
      const response = await axiosInstance.get('/v1/organization', {
        params: {
          search: searchVal,
          page: pageVal,
          limit: organisationPerPage
        }
      });

      const { data, total, totalPages } = response.data;
      setOrganisationList(data || []);
      setTotalOrganizations(total);
      setTotalPages(totalPages);
      setLoading(0);
    } catch (error) {
      setLoading(2);
      console.error("Error fetching organisation list:", error);
    }
  };

  useEffect(() => {
    fetchOrganisationList();
  }, [pageVal]);

  useEffect(() => {
    if (pageVal === 1) {
      fetchOrganisationList();
    } else {
      setPageVal(1);
    }
  }, [searchVal, status]);

  const handleStatusToggle = async (orgId, isActive) => {
    setStatusLoading(orgId);
    const action = isActive ? "deactivate" : "activate";

    try {
      await axiosInstance.patch(`/v1/organization/${orgId}/${action}`);

      toast.success(`Organisation ${action}d successfully`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: {
          background: "#fff",
          color: colors.primary.headingsBody,
          border: `1px solid ${colors.primary.headingsBody}`,
        },
      });

      fetchOrganisationList();
    } catch (error) {
      console.error(`Error ${action}ing organisation:`, error);
      toast.error(`Failed to ${action} organisation`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: {
          background: "#fff",
          color: colors.primary.headingsBody,
          border: `1px solid ${colors.primary.headingsBody}`,
        },
      });
    } finally {
      setStatusLoading(null);
    }
  };

  const handleUpdateLogo = (orgId) => {
    navigate(`/super-admin/logo-customisation/${orgId}`);
  };

  const handleMockAdmin = async (orgId) => {
    setLoadingMockAdmin(orgId);
    setShowTooltip((prev) => ({ ...prev, [orgId]: false }));

    try {
      const response = await axiosInstance.post(`/v1/organization/${orgId}/impersonate-admin`);
      const responseData = response.data;

      localStorage.setItem("userDetails", JSON.stringify(responseData.data));
      await fetchLogos();

      // Check if device is mobile
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

      if (isMobile) {
        window.location.href = "/dashboard/organisation"; // Open in same tab for mobile
      } else {
        window.open("/dashboard/organisation", "_blank"); // Open in new tab for desktop
      }
    } catch (error) {
      console.error("Error impersonating admin:", error);
      toast.error("Failed to Impersonate Admin", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: {
          background: "#fff",
          color: colors.primary.headingsBody,
          border: `1px solid ${colors.primary.headingsBody}`,
        },
      });
    } finally {
      setLoadingMockAdmin(null);
    }
  };

  const handleEditClick = (orgId) => {
    navigate(`/super-admin/edit-organisation/${orgId}`);
  };

  const handleCreateOrganisation = () => {
    navigate("/super-admin/create-organisation");
  };

  const pgItem1 = 1;
  const pgItem2 = totalPages >= 2 ? 2 : null;
  const pgItem3 = totalPages >= 3 ? 3 : null;

  useEffect(() => {
    if (pageLoading) {
      fetchOrganisationList();
      setPageLoading(false);
    }
  }, [pageVal, pageLoading]);

  return (
    <div className="p-6">
      <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center mb-6">
        <h3 className="text-2xl font-semibold text-gray-800">Organisations List</h3>

        <div className="flex flex-col sm:flex-row gap-4 mt-2 sm:mt-0 sm:ml-auto">
          <Search searchVal={searchVal} setSearchVal={setSearchVal} />

          <button
            className="inline-flex items-center justify-center w-full sm:w-auto min-w-[200px] px-6 py-2.5 bg-[#d16f53] text-white rounded-lg hover:bg-[#c05a3f] focus:ring-4 focus:ring-[#d16f53]/20 transition-all duration-200 font-medium text-sm whitespace-nowrap"
            onClick={handleCreateOrganisation}
          >
            <i className="fas fa-plus mr-2"></i>Create Organisation
          </button>
        </div>
      </div>

      <div className="h-[calc(100vh-12rem)] overflow-y-auto bg-gradient-to-b from-white to-accent-light/10 p-6">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-8 sticky top-0 bg-gray-100">No</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-48 sticky top-0 bg-gray-100">Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-48 sticky top-0 bg-gray-100">Email</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-24 sticky top-0 bg-gray-100">Phone</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-24 sticky top-0 bg-gray-100"></th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-40 sticky top-0 bg-gray-100">Status</th>
                <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-40 sticky top-0 bg-gray-100">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {loading === 0 && organisationList && organisationList.length > 0 ? (
                organisationList.map((org, index) => (
                  <tr key={index} className="h-18">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 max-w-[2rem] truncate">
                      {(pageVal - 1) * organisationPerPage + index + 1}.
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 max-w-[12rem] truncate">
                      {org.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 max-w-[12rem] truncate">
                      {org.email}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 max-w-[6rem] truncate">
                      {org.phone}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 max-w-[6rem] truncate">
                      {/* {org.admins && org.admins.length > 0 ? org.admins[0].name : "NA"} */}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap max-w-[10rem]">
                      <div className="flex items-center">
                        {statusLoading === org._id ? (
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-[#166473]"></div>
                        ) : (
                          <ToggleSwitch
                            isChecked={org.isActive}
                            handleToggle={() => {
                              handleStatusToggle(org._id, org.isActive);
                            }}
                          />
                        )}
                        <span className="ml-2 text-sm font-medium text-gray-700">
                          {org.isActive ? "Active" : "Inactive"}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap max-w-[12rem] flex justify-center space-x-3">
                      <div className="flex justify-center space-x-3">
                        <button
                          className="p-2 rounded-lg bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors duration-200"
                          onClick={() => handleEditClick(org._id)}
                        >
                          <HiOutlinePencilAlt size={18} />
                        </button>
                      </div>
                      <div className="flex justify-center space-x-3">
                        <button
                          className="p-2 rounded-lg bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors duration-200"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleMockAdmin(org._id);
                          }}
                          disabled={loadingMockAdmin === org._id}
                        >
                          {loadingMockAdmin === org._id ? (
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#166473]"></div>
                          ) : (
                            <HiOutlineEye size={18} />
                          )}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : loading === 1 ? (
                <tr>
                  <td colSpan="7" className="px-6 py-12">
                    <div className="flex items-center justify-center">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
                    </div>
                  </td>
                </tr>
              ) : loading === 2 ? (
                <tr>
                  <td colSpan="7" className="px-6 py-12">
                    <div className="flex flex-col items-center">
                      <MdOutlineWifiTetheringErrorRounded size={120} className="text-gray-400" />
                      <h2 className="mt-4 text-xl font-semibold text-gray-800">Error fetching data</h2>
                      <p className="mt-2 text-gray-600">Check your network and try again</p>
                    </div>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan="7" className="px-6 py-12">
                    <div className="flex flex-col items-center">
                      <IoSearch size={120} className="text-gray-400" />
                      <h2 className="mt-4 text-xl font-semibold text-gray-800">No results found</h2>
                      <p className="mt-2 text-gray-600">Adjust your filters and try again</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {loading === 0 && organisationList.length !== 0 && (
          <div className="px-6 py-4 flex flex-col md:flex-row items-center justify-between border-t border-gray-200">
            <div className="mb-4 md:mb-0">
              <p className="text-sm text-gray-700">
                Showing {organisationList.length !== 0 ? organisationPerPage * (pageVal - 1) + 1 : 0} to{' '}
                {organisationList ? organisationPerPage * (pageVal - 1) + organisationList.length : 0} of{' '}
                {totalOrganizations} entries
              </p>
            </div>
            {totalPages > 1 && (
              <nav className="flex items-center space-x-2">
                <button
                  onClick={handlePreviousPageClick}
                  disabled={pageVal === 1 || pageLoading}
                  className={`p-2 rounded-lg ${pageVal === 1 || pageLoading
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                    }`}
                >
                  {pageLoading ? (
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#166473]"></div>
                  ) : (
                    <FaAngleLeft />
                  )}
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    disabled={pageLoading}
                    className={`px-3 py-1 rounded-lg ${page === pageVal
                      ? 'bg-[#166473] text-white'
                      : 'bg-white text-gray-700 hover:bg-gray-50'
                      } ${pageLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                  >
                    {pageLoading && page === pageVal ? (
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    ) : (
                      page
                    )}
                  </button>
                ))}
                <button
                  onClick={handleNextPageClick}
                  disabled={pageVal >= totalPages || pageLoading}
                  className={`p-2 rounded-lg ${pageVal >= totalPages || pageLoading
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                    }`}
                >
                  {pageLoading ? (
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#166473]"></div>
                  ) : (
                    <FaAngleRight />
                  )}
                </button>
              </nav>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ListOrganisation;
